import formatNumber from "./format.number";

export function getVehicleValue(product, key) {
  const read = (source) => key.split(".").reduce((value, part) => value?.[part], source);
  for (const source of [product, product?.properties]) {
    const value = read(source);
    if (value !== null && value !== undefined && value !== "") return value;
  }
  return "-";
}

export function formatVehicleNumber(value, unit = "") {
  if (value === null || value === undefined || value === "") return "-";
  const raw = String(value).trim();
  if (/^(?:-|n\/?a)$/i.test(raw)) return raw;
  // Accept numeric API values and values that already include their unit.
  const numeric = raw.replace(/,/g, "").replace(/\s*(?:kwh|kw|km|cc|inches|inch)\s*$/i, "");
  if (!/^[+-]?\d+(?:\.\d+)?$/.test(numeric)) return raw;
  return `${formatNumber(numeric)}${unit ? ` ${unit}` : ""}`;
}

export function formatFuelType(value) {
  const key = String(value ?? "-").trim().toLowerCase().replace(/[\s-]+/g, "_");
  const names = {
    petrol: "Petrol", diesel: "Diesel", electric: "Electric",
    ev: "Electric", bev: "Battery Electric", battery_electric: "Battery Electric",
    hybrid: "Hybrid", hev: "Hybrid", phev: "Plug-in Hybrid",
    plug_in_hybrid: "Plug-in Hybrid", plugin_hybrid: "Plug-in Hybrid",
    mhev: "Mild Hybrid", mild_hybrid: "Mild Hybrid",
    hydrogen: "Hydrogen", fcev: "Fuel Cell Electric", lpg: "Liquefied Petroleum Gas",
    cng: "Compressed Natural Gas",
  };
  return names[key] || key.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
